import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { CurrencyCode, Currency, NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';

@Component({
	selector: 'app-currency-sel',
	templateUrl: './currency-sel.component.html',
	styleUrls: ['./currency-sel.component.scss']
})
export class CurrencySelComponent implements OnInit {

	private _val: CurrencyCode = 'USD';

	@Input('value')
	public set value(val: CurrencyCode) {
		if (val !== this._val) {
			this._val = val;
			this.valueChange.emit(val);
		}
	}
	public get value(): CurrencyCode {
		return this._val;
	}
	@Output()
	public valueChange = new EventEmitter<CurrencyCode>();


	constructor() { }

	public currencies: Array<Currency> = NumberQualifierService.currencies;

	ngOnInit(): void {

	}


}
